import alchemist from '../sounds/anime/alchemist.mp3';
import beck from '../sounds/anime/beck.mp3';
import fate from '../sounds/anime/fate.mp3';
import grandblue from '../sounds/anime/grandblue.mp3';
import souleater from '../sounds/anime/souleater.mp3';
import steinsgate from '../sounds/anime/steinsgate.mp3';

import alladin from '../sounds/cartoons/alladin.mp3'
import ducktales from '../sounds/cartoons/ducktales.mp3'
import frozen from '../sounds/cartoons/frozen.mp3'
import mulan from '../sounds/cartoons/mulan.mp3'
import chipanddale from '../sounds/cartoons/rescuerangers.mp3'
import tmnt from '../sounds/cartoons/tmnt.mp3'

import ac2 from '../sounds/games/ac2.mp3'
import battlefield from '../sounds/games/battlefield.mp3'
import divinity from '../sounds/games/divinity.mp3'
import fallout4 from '../sounds/games/fallout4.mp3'
import morrowind from '../sounds/games/morrowind.mp3'
import undertale from '../sounds/games/undertale.mp3'

import badboys from '../sounds/movies/badboys.mp3'
import ghostbusters from '../sounds/movies/ghostbusters.mp3'
import lotr from '../sounds/movies/lotr.mp3'
import mile8 from '../sounds/movies/mile8.mp3'
import pirates from '../sounds/movies/pirates.mp3'
import transformers from '../sounds/movies/transformers.mp3'

import angel from '../sounds/series/angel.mp3'
import bigbang from '../sounds/series/bigbang.mp3'
import detective from '../sounds/series/detective.mp3'
import smallvile from '../sounds/series/smallvile.mp3'
import supernatural from '../sounds/series/supernatural.mp3'
import trueblood from '../sounds/series/trueblood.mp3'

import animalworld from '../sounds/tvshows/animalworld.mp3'
import director from '../sounds/tvshows/director.mp3'
import fort from '../sounds/tvshows/fort.mp3'
import jungle from '../sounds/tvshows/jungle.mp3'
import pimpmyride from '../sounds/tvshows/pimpmyride.mp3'
import xfactor from '../sounds/tvshows/xfactor.mp3'

import applause from '../sounds/applause.mp3'
import wrong from '../sounds/error.mp3'
import right from '../sounds/right.mp3'


const sounds = {
    anime: {
        alchemist: alchemist,
        beck: beck,
        fate: fate,
        grand_blue: grandblue,
        soul_eater: souleater,
        steins_gate: steinsgate,
    },
    cartoons: {
        alladin: alladin,
        duck_tales: ducktales,
        frozen: frozen,
        mulan: mulan,
        chip_and_dale: chipanddale,
        tmnt: tmnt,
    },
    games: {
        ac2: ac2,
        battlefield: battlefield,
        divinity: divinity,
        fallout4: fallout4,
        morrowind: morrowind,
        undertale: undertale,
    },
    movies: {
        badboys: badboys,
        ghostbusters: ghostbusters,
        lotr: lotr,
        mile8: mile8,
        pirates: pirates,
        transformers: transformers,
    },
    series: {
        angel: angel,
        bigbang: bigbang,
        detective: detective,
        smallvile: smallvile,
        supernatural: supernatural,
        trueblood: trueblood,
    },
    tv_shows: {
        animalworld: animalworld,
        director: director,
        fort: fort,
        jungle: jungle,
        pimpmyride: pimpmyride,
        xfactor: xfactor,
    },
    etc:{
        applause:applause,
        right:right,
        wrong:wrong,
    }
};

export default sounds